// extracted by mini-css-extract-plugin
module.exports = {"smallVideo":"popup_smallVideo__1Z90n","modalTitle":"popup_modalTitle__B76SQ","paragraph":"popup_paragraph__3kukX","bottomButtons":"popup_bottomButtons__1CENk"};